import { Action } from '@ngrx/store';

/**
 * SortActionTypes
 */
export const enum SortActionTypes {
  LOAD_SORT_BY = '[Sort] Load Sort By',
  CLEAR_SORT_BY = '[Sort] Clear Sort By',
}

/**
 * LoadSortBy
 */
interface LoadSortBy extends Action {
  type: SortActionTypes.LOAD_SORT_BY;
  payload: any;
}

/**
 * ClearSortBy
 */
interface ClearSortBy extends Action {
  type: SortActionTypes.CLEAR_SORT_BY;
}

/**
 * SortActions
 */
export type SortActions = LoadSortBy | ClearSortBy;
